import { makeAutoObservable } from 'mobx';

import { UserType } from '../constants';
import { IServerMessageModel, ServerMessageModel } from './ServerMessageModel';

export class MessageModel {
  private _fileIds: number[];
  private _failed: boolean;
  private _serverMessage: ServerMessageModel;
  constructor(data: IServerMessageModel) {
    this._fileIds = [];
    this._failed = false;
    this._serverMessage = new ServerMessageModel(data);
    makeAutoObservable(this);
  }
  get fileIds() {
    return this._fileIds || [];
  }
  set fileIds(fileIds: number[]) {
    this._fileIds = fileIds;
  }
  get failed() {
    return this._failed || false;
  }
  set failed(value: boolean) {
    this._failed = value;
  }

  get id() {
    return this._serverMessage.id;
  }
  get groupId() {
    return this._serverMessage.groupId;
  }
  get from() {
    return (
      this._serverMessage.from || {
        id: -1,
        name: '',
        type: UserType.MANAGER,
        thumbnail: '',
      }
    );
  }
  get displayName() {
    return this.from.name || this.from.type === UserType.CLIENT ? '고객' : '나';
  }
  get content() {
    return this._serverMessage.content || '';
  }
  get files() {
    return this._serverMessage.files || [];
  }
  set files(files) {
    this._serverMessage.files = files;
  }
  get createdAt() {
    return this._serverMessage.createdAt || '';
  }
  get modified() {
    return this._serverMessage.modified;
  }
}
